import {
  Combobox,
  ComboboxContent,
  ComboboxTrigger,
} from '@/components/Combobox/Combobox';
import { useArbeitsbereiche } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useArbeitsbereiche/useArbeitsbereiche';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useTranslation } from 'react-i18next';

export function ArbeitsbereichMultiSelect({
  values,
  hideArbeitsbereiche,
  handleChange,
}: {
  values: string[];
  hideArbeitsbereiche?: string[];
  handleChange: (value: string[]) => void;
}) {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const { arbeitsbereiche } = useArbeitsbereiche(currentStandort.id);

  const options = arbeitsbereiche
    .filter((ab) => !hideArbeitsbereiche?.includes(ab.id))
    .map((option) => {
      return {
        value: option.id,
        label: option.name,
        color: option.getBorderColor(),
        ...option,
      };
    });

  const selectedArbeitsbereiche = options
    .filter((ab) => values.includes(ab.id))
    .map((ab) => ab.id);

  return (
    <Combobox
      options={options}
      values={selectedArbeitsbereiche}
      onValuesChange={handleChange}
      placeholder={t(
        `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.sekundaereArbeitsbereiche.placeholder`,
      )}>
      <ComboboxTrigger />
      <ComboboxContent />
    </Combobox>
  );
}
